import React from "react";
import { useAppSelector } from "src/store/hooks";
import CardImage from "src/componets/CardImage";
import { formattedDate } from "src/helpers/DateHelpers";
import { EntityId } from "@reduxjs/toolkit";

import {Form, Radio, Spin} from "antd";
import '../style.scss';

const _TemplatesSelect = () => {
  const ids = useAppSelector(state => state.sendgrid.templates.ids);
  const templates = useAppSelector(state => state.sendgrid.templates.entities);
  const status    = useAppSelector(state => state.sendgrid.templates.status);

  const renderTemplate = (id: EntityId) => {
    const template = templates[id];

    if (!template) {
      return;
    }

    const formattedUpdatedAt = formattedDate(template.updated_at);

    return (
      <CardImage
        key={template.id}
        image={template.thumbnail_url}
        size='medium'
        stats={[
          <Radio value={template.id}>{template.name}</Radio>
        ]}
      >
        <div className='v-small_text'>
          {formattedUpdatedAt && <small>{formattedUpdatedAt.date} <small>{formattedUpdatedAt.time}</small></small> }
        </div>
      </CardImage>
    )
  }

  return (
    <div className='v-sendgrid-templates_select'>
      {status === 'loading' && <Spin /> }

      <Form.Item
        name='email_template'
        rules={[{ required: true, message: 'Missing template' }]}
      >
        <Radio.Group>
          {ids && ids.map(renderTemplate)}
        </Radio.Group>
      </Form.Item>
    </div>
  )
}

export default _TemplatesSelect;
